// Display constants + interfaces ported from mobile components/analysis/analysisData.ts.
// The pre-transformed TF_CARDS/VWAP/KEY_LEVELS mocks are intentionally dropped —
// in the web app these come from the live WS payload via brainerCoreTransform.

export const PAIRS: string[] = [
  'BTC/USDT',
  'ETH/USDT',
  'SOL/USDT',
  'BNB/USDT',
  'XRP/USDT',
  'DOGE/USDT',
  'ADA/USDT',
  'AVAX/USDT',
  'DOT/USDT',
  'LINK/USDT',
  'MATIC/USDT',
  'LTC/USDT',
  'TRX/USDT',
  'TON/USDT',
  'NEAR/USDT',
  'ARB/USDT',
  'OP/USDT',
  'INJ/USDT',
  'SUI/USDT',
  'APT/USDT',
  'ETH/BTC',
];

export const TIMEFRAMES: { label: string; tag: string; tradingStyle: string }[] = [
  { label: '5m', tag: '5m', tradingStyle: 'Scalp' },
  { label: '15m', tag: '15m', tradingStyle: 'Day' },
  { label: '30m', tag: '30m', tradingStyle: 'Day' },
  { label: '1H', tag: '1H', tradingStyle: 'Swing' },
  { label: '4H', tag: '4H', tradingStyle: 'Swing' },
  { label: '12H', tag: '12H', tradingStyle: 'Position' },
  { label: '1D', tag: '1D', tradingStyle: 'Position' },
  { label: '3D', tag: '3D', tradingStyle: 'Position' },
  { label: 'W', tag: 'W', tradingStyle: 'Macro' },
];

/** Timeframe tags that MEXC supports (same set for spot and futures). */
export const MEXC_SUPPORTED_TFS = new Set(['1m', '5m', '15m', '30m', '1H', '4H', '8H', '1D', 'W', '1M']);

/** Pairs the backend currently serves analysis for; others are shown disabled. */
export const AVAILABLE_PAIRS = new Set(['BTC/USDT', 'ETH/USDT']);

export interface MetricItem {
  label: string;
  value: string;
  sub?: string;
  color?: string;
  barPercent?: number;
  barColor?: string;
  valueFontSize?: number;
}

export interface SignalItem {
  label: string;
  age: string;
  color: string;
  isNow?: boolean;
}

export interface SignalGroups {
  bullish: SignalItem[];
  bearish: SignalItem[];
}

export interface TFCardData {
  role: string;
  name: string;
  isBullish: boolean;
  metrics: MetricItem[];
  signals: SignalGroups;
  gradientColors: readonly [string, string, ...string[]];
}

export interface VWAPItem {
  label: string;
  value: string;
  sub: string;
  isAbove: boolean;
  isFullWidth?: boolean;
}

export interface LevelItem {
  label: string;
  value: string;
  rangeTo?: string;
  note?: string;
}

// ── Deep-analysis (Stage 4) display interfaces — ported from analysisData.ts ──

export interface TradeMetricItem {
  label: string;
  value: string;
  color?: string;
  note?: string;
  fullWidth?: boolean;
  extraValue?: string;
  extraColor?: string;
  extraNote?: string;
}

export interface ExecuteData {
  side: 'LONG' | 'SHORT';
  entry: number;
  stopLoss: number;
  tp1: number | null;
  tp2: number | null;
  tp1Rr: number | null;
  tp2Rr: number | null;
}

export interface TradeIdea {
  type: 'LONG' | 'SHORT';
  dirLabel: string;
  badge: string;
  badgeVariant: 'best' | 'decent';
  metrics: TradeMetricItem[];
  executeLabel: string;
  executeData: ExecuteData;
}
